var map = {
	"./es/announcements/list.json": [
		381,
		4
	],
	"./es/common.json": [
		382,
		5
	],
	"./es/degree-processes/documents.json": [
		383,
		6
	],
	"./es/degree-processes/main.json": [
		384,
		7
	],
	"./es/petitions.json": [
		385,
		8
	],
	"./es/survey.json": [
		386,
		9
	],
	"./es/terms.json": [
		387,
		10
	],
	"./es/translation.json": [
		388,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 270;
module.exports = webpackAsyncContext;